// import React, { useEffect, useState } from "react";
// import { Formik } from "formik";
// import * as Yup from "yup";
// import { useDispatch, useSelector } from "react-redux";
// import { actionTypes } from "redux/profile/get_kyc_profile";
// import { Box, TextField, CircularProgress } from "@mui/material";
// import { makeStyles } from "@mui/styles";
// import { MdOutlineRefresh } from "react-icons/md";
// import { getUrl } from "common/components/apiConfig";
// import axios from "axios";

// const useStyles = makeStyles((theme) => ({
//   root: {
//     backgroundColor: "white",
//     padding: 15,
//     borderRadius: 8,
//     [theme.breakpoints.down("500")]: {
//       padding: 10,
//     },
//   },
//   input: {
//     width: 370,
//     [theme.breakpoints.down("500")]: {
//       width: 270,
//       margin: "auto",
//     },
//   },
//   customInput: {
//     minHeight: 28,
//     [theme.breakpoints.down("500")]: {
//       margin: 0,
//     },
//   },
// }));

// export default function StepTwo({
//   setIndexChild,
//   textError,
//   national_id,
//   setLoading,
//   title,
//   loading,
// }) {
//   const classes = useStyles();
//   const dispatch = useDispatch();
//   const [apiResponse, setApiResponse] = useState(null);

//   const reducerProfile = useSelector((state) => state.reducer_get_kyc_profile);

//   useEffect(() => {
//     if (reducerProfile.isOk) {
//       setLoading(false);
//       setIndexChild(2);
//     }
//   }, [reducerProfile.isOk]); //eslint-disable-line react-hooks/exhaustive-deps

//   useEffect(() => {
//     setLoading(reducerProfile.loading);
//   }, [reducerProfile.loading]); //eslint-disable-line react-hooks/exhaustive-deps

//   useEffect(() => {
//     return () => {
//       dispatch({ type: actionTypes.get_kyc_profileLoading, payload: false });
//       dispatch({ type: actionTypes.remove_profileAsync });
//     };
//   }, []); //eslint-disable-line react-hooks/exhaustive-deps

//   const fetchData = async () => {
//     try {
//       const response = await apiCall();
//       setApiResponse(response.data);
//     } catch (error) {
//       console.error("Error fetching data:", error);
//     }
//   };

//   const apiCall = () => {
//     const config = {
//       baseURL: getUrl(),
//       method: "POST",
//       headers: {
//         "content-type": "application/json",
//         "Access-Control-Allow-Origin": "*",
//       },
//       url: "login",
//       data: {
//         api_key: "d025488f-8ec6-4434-afbe-b6a5343815a7",
//         token: null,
//         member_id: null,
//         table: "clubmember",
//         method_type: "get_captcha",
//         data: {},
//       },
//     };

//     return axios(config);
//   };

//   const initialValues = {
//     otp: "",
//     captcha: "",
//   };

//   const validateSchema = Yup.object().shape({
//     otp: Yup.string().required("کد تایید مورد نیاز است."),
//     captcha: Yup.string()
//       .required("کد امنیتی مورد نیاز است.")
//       .length(4, "کد امنیتی باید 4 کاراکتر باشد."),
//   });

//   const onSubmit = (values, { setSubmitting }) => {
//     const _data = {
//       national_id: national_id,
//       otp: values.otp,
//       captcha_value: values.captcha,
//       captcha_id: apiResponse?.response?.data?._id,
//     };

//     dispatch({ type: actionTypes.get_kyc_profileAsync, payload: _data });
//   };

//   const base64Image = apiResponse?.response?.data?.img;
//   const imgSrc = base64Image?.startsWith("data:image")
//     ? base64Image
//     : `data:image/jpeg;base64,${base64Image}`;

//   const handleRefreshClick = () => {
//     fetchData();
//   };
//   useEffect(() => {
//     handleRefreshClick();
//   }, []);

//   return (
//     <div className={classes.root}>
//       <h1 className="pr-3 mb-3 mt-2 text-[#646464] text-lg">{title}</h1>
//       <p className="pr-5 md:pr-10">
//         لطفا تا دریافت پیامک تایید منتظر بمانید و از این صفحه خارج نشوید.
//       </p>
//       <Formik
//         initialValues={{ ...initialValues }}
//         validationSchema={validateSchema}
//         onSubmit={onSubmit}
//       >
//         {({ values, touched, errors, handleSubmit, setFieldValue }) => (
//           <form onSubmit={handleSubmit}>
//             <Box className="flex items-center flex-col sm:flex-col justify-center">
//               <Box className="mr-0 sm:mr-20 w-full">
//                 <TextField
//                   className={classes.input}
//                   id="otp"
//                   label="کد تایید"
//                   value={values.otp}
//                   onChange={(e) => setFieldValue("otp", e.target.value)}
//                   margin="normal"
//                   size="small"
//                   variant="outlined"
//                   InputProps={{ classes: { input: classes.customInput } }}
//                   error={touched.otp && Boolean(errors.otp)}
//                   helperText={touched.otp && errors.otp}
//                 />
//               </Box>
//               <Box className="mr-0 sm:mr-20 w-full ">
//                 <TextField
//                   autoFocus
//                   className={classes.input}
//                   required
//                   size="small"
//                   placeholder="کد امنیتی"
//                   name="captcha"
//                   value={values.captcha}
//                   onChange={(e) => setFieldValue("captcha", e.target.value)}
//                   inputProps={{ maxLength: 4 }}
//                   InputProps={{
//                     endAdornment: (
//                       <>
//                         {imgSrc ? (
//                           <img
//                             style={{ maxHeight: 36 }}
//                             height={16}
//                             alt="captcha"
//                             src={imgSrc}
//                           />
//                         ) : (
//                           <CircularProgress size={16} />
//                         )}
//                         <MdOutlineRefresh
//                           onClick={handleRefreshClick}
//                           style={{ cursor: "pointer", marginLeft: 4 }}
//                           size={44}
//                         />
//                       </>
//                     ),
//                   }}
//                   error={touched.captcha && Boolean(errors.captcha)}
//                   helperText={touched.captcha && errors.captcha}
//                 />
//               </Box>
//             </Box>
//             <Box mt={2} display="flex" justifyContent="flex-end">
//               <button
//                 className={`border border-primary text-primary rounded-md py-1 px-5 ml-6 ${
//                   !loading && "hover:text-white hover:bg-primary"
//                 }`}
//                 type="submit"
//                 disabled={loading}
//               >
//                 ثبت درخواست
//                 {loading && <CircularProgress size={16} />}
//               </button>
//               <button
//                 className="border border-red-600 py-1 px-5 rounded-md text-red-600 ml-2 hover:bg-red-600 hover:text-white"
//                 onClick={() => setIndexChild(0)}
//               >
//                 لغو
//               </button>
//             </Box>
//           </form>
//         )}
//       </Formik>
//     </div>
//   );
// }
import { Button, CircularProgress, Modal, TextField } from "@mui/material";
import axios from "axios";
import { getlocalStorageLogin, getUrl } from "common/components/apiConfig";
import { convertDigitToEnglish } from "common/method/convertDigitToEnglish";
import {
  handleNotificationAlertCatch,
  handleNotificationAlertTryUpdate,
} from "common/method/handleNotificationAlert";
import { useFormik } from "formik";
import { useEffect, useState } from "react";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import { IoMdClose } from "react-icons/io";
import { MdOutlineKeyboardAlt, MdOutlineRefresh } from "react-icons/md";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import Keyboard from "react-simple-keyboard";
import { insert_pishro_force_set_password } from "redux/clubMember/pishro_force_set_password";
import { insert_pishro_send_otp } from "redux/clubMember/pishro_send_otp";
import { actionTypes as notif } from "redux/notificationAlert";
import * as Yup from "yup";

const ChangePasswordWithoutAuth = () => {
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [isLoadingOtp, setIsLoadingOtp] = useState(false);
  const dispatch = useDispatch();
  const [showPass, setshowPass] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [showKeyPass, setShowKeyPass] = useState(false);
  const [showKeyConfirm, setShowKeyConfirm] = useState(false);
  const [layoutName, setLayoutName] = useState("default");
  const [inputPass, setInputPass] = useState("");
  const [confirmPass, setConfirmPass] = useState("");
  const [minutes, setMinutes] = useState(1);
  const [seconds, setSeconds] = useState(60);
  const [startTimer, setStartTimer] = useState(true);
  const handleClickPass = () => {
    setshowPass((prev) => !prev);
  };
  const handleClickConfirm = () => {
    setShowConfirm((prev) => !prev);
  };

  const [apiResponse, setApiResponse] = useState(null);
  const [shouldFetchData, setShouldFetchData] = useState(true);

  const fetchData = async () => {
    try {
      const response = await apiCall();
      setApiResponse(response.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    if (shouldFetchData) {
      fetchData();
      setShouldFetchData(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shouldFetchData]);

  const apiCall = () => {
    let config = {
      baseURL: getUrl(),
      method: "POST",
      headers: {
        "content-type": "application/json",
        "Access-Control-Allow-Origin": "*",
      },
      url: "login",
      data: {
        api_key: "d025488f-8ec6-4434-afbe-b6a5343815a7",
        token: null,
        member_id: null,
        table: "clubmember",
        method_type: "get_captcha",
        data: {},
      },
    };

    return axios(config);
  };

  const base64Image = apiResponse?.response?.data?.img;
  const imgSrc = base64Image?.startsWith("data:image")
    ? base64Image
    : `data:image/jpeg;base64,${base64Image}`;

  const initialValues = {
    password: "",
    confirmPassword: "",
    captcha: "",
    Otp: "",
  };

  let errorPassword =
    "رمز عبور باید ۸ کاراکتر و شامل عدد و حروف کوچک و بزرگ انگلیسی باشد";

  const ChangePassSchema = Yup.object().shape({
    password: Yup.string()
      .min(8, "حداقل باید 8 رقم  باشد")
      .required("وارد کردن رمز عبور الزامی است")
      .matches(
        // /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d*@$!%*#?&]{8,}$/,
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/,
        errorPassword,
      ),
    captcha: Yup.string().required("وارد کردن کد کپچا الزامی است."),

    confirmPassword: Yup.string()
      .oneOf([Yup.ref("password")], "رمز عبور یکسان نیست")
      .required("وارد کردن تکرار رمز عبور الزامی است."),
    Otp: Yup.string().required("وارد کردن کد امنیتی الزامی است."),
  });

  const handleRoute = () => {
    document.cookie = "is_expired=false; path=/;";

    history.push("/home");
  };

  const getInputClasses = (fieldname) => {
    if (formik.touched[fieldname] && formik.errors[fieldname]) {
      return "is-invalid";
    }

    if (formik.touched[fieldname] && !formik.errors[fieldname]) {
      return "is-valid";
    }

    return "";
  };

  const formik = useFormik({
    initialValues,
    validationSchema: ChangePassSchema,
    onSubmit: (values, { setStatus, setSubmitting }) => {
      const ENGpassword = convertDigitToEnglish(values.password);
      const ENGOtp = convertDigitToEnglish(values.Otp);
      const ENGCaptcha = convertDigitToEnglish(values.captcha);
      setLoading(true);
      handleUpdatepass({
        otp: ENGOtp,
        new_password: ENGpassword,
        captcha_id: apiResponse?.response?.data?._id,
        captcha_value: ENGCaptcha,
      });
    },
  });

  const handleClearInput = () => {
    setInputPass("");
    formik.setFieldValue("password", "");
  };

  const onChange = (newInput) => {
    if (showKeyPass) {
      return setInputPass(newInput);
    } else if (showKeyConfirm) {
      return setConfirmPass(newInput);
    }
  };
  const handleClearInputConfirm = () => {
    setConfirmPass("");
    formik.setFieldValue("confirmPassword", "");
  };

  const onKeyPress = (button) => {
    if (button === "{shift}" || button === "{lock}") handleShift();
  };

  const handleShift = () => {
    setLayoutName((prevLayout) =>
      prevLayout === "default" ? "shift" : "default",
    );
  };
  useEffect(() => {
    formik.setFieldValue("password", inputPass);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputPass]);
  useEffect(() => {
    formik.setFieldValue("confirmPassword", confirmPass);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [confirmPass]);
  const handleRefreshClick = () => {
    setShouldFetchData(true);
  };

  useEffect(() => {
    if (!startTimer) return;
    let myInterval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }
      if (seconds === 0) {
        if (minutes === 0) {
          clearInterval(myInterval);
          setStartTimer(false);
        } else {
          setMinutes(minutes - 1);
          setSeconds(59);
        }
      }
    }, 1000);
    return () => {
      clearInterval(myInterval);
    };
  }, [minutes, seconds, startTimer]);
  const adminObj = getlocalStorageLogin();
  const userObject = adminObj?.user;

  const nationalId = userObject?.member_national_id;

  const handleSendOtp = () => {
    if (!nationalId) {
      return dispatch({
        type: notif.warning,
        textAlert: "کد ملی یافت نشد!",
      });
    }
    let data = {
      national_id: nationalId,
      flag_info: "set_password",
    };
    setIsLoadingOtp(true);

    insert_pishro_send_otp({ data })
      .then((res) => {
        handleNotificationAlertTryUpdate(res);
      })
      .catch(() => handleNotificationAlertCatch())
      .finally(() => {
        setIsLoadingOtp(false);
      });
  };
  const handleUpdatepass = ({
    otp,
    new_password,
    captcha_id,
    captcha_value,
  }) => {
    if (!nationalId) {
      return dispatch({
        type: notif.warning,
        textAlert: "کد ملی یافت نشد!",
      });
    }
    let data = {
      otp: otp,
      new_password: new_password,
      captcha_id: captcha_id,
      captcha_value: captcha_value,
    };
    setLoading(true);

    insert_pishro_force_set_password({ data })
      .then((res) => {
        const data = res.data?.response?.data?.result;
        if (data === "updated" || data === "noop") {
          handleRoute();
        }
        handleNotificationAlertTryUpdate(res);
      })
      .catch(() => handleNotificationAlertCatch())
      .finally(() => {
        setLoading(false);

        handleRefreshClick();
      });
  };

  return (
    <>
      <div
        className="flex flex-col"
        style={{ backgroundColor: "white", padding: 15, borderRadius: 8 }}
      >
        <form
          style={{ maxWidth: 600, margin: "0px auto" }}
          onSubmit={formik.handleSubmit}
        >
          <div className="fv-plugins-icon-container relative mt-5 border rounded-md ">
            {showKeyPass && (
              <Modal
                sx={{
                  "& .muirtl-i9fmh8-MuiBackdrop-root-MuiModal-backdrop": {
                    backgroundColor: "transparent",
                  },
                }}
                open={showKeyPass}
                onClose={() => {
                  setShowKeyPass(false);
                }}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
              >
                <div
                  style={{
                    display: "flex",
                    backgroundColor: "#ffffff",
                    zIndex: 100,
                    borderRadius: 5,
                    position: "absolute",
                    top: "50%",
                    left: "17%",
                    transform: "translate(0%, -48%)",
                    outline: 0,
                    border: 0,
                    boxShadow: 24,
                    maxWidth: "100%",
                    width: "auto",
                    maxHeight: "80vh",
                    overflowY: "auto",
                  }}
                >
                  <div style={{ direction: "ltr" }}>
                    <Keyboard
                      input={inputPass} // Pass the input directly
                      layoutName={layoutName}
                      onChange={onChange}
                      onKeyPress={onKeyPress}
                    />
                  </div>
                </div>
              </Modal>
            )}
            <input
              placeholder="رمز عبور جدید "
              type={showPass ? "text" : "password"}
              className={`w-full  h-12 py-4 px-5 focus:border-gray-400 outline-none rounded-md ${getInputClasses(
                "password",
              )} authInput`}
              name="password"
              onChange={formik.handleChange}
              value={formik.values.password}
              {...formik.getFieldProps("password")}
            />

            <div
              className="absolute top-3 left-12 text-gray-600 cursor-pointer"
              onClick={() => handleClickPass()}
            >
              {showPass ? (
                <AiOutlineEyeInvisible size={25} />
              ) : (
                <AiOutlineEye size={25} />
              )}
            </div>
            <div className="absolute top-[13px] left-4 text-gray-600 cursor-pointer">
              <MdOutlineKeyboardAlt
                size={25}
                onClick={() => setShowKeyPass((prev) => !prev)}
                style={{ cursor: "pointer" }}
              />
            </div>
            {formik.values.password !== null && (
              <div className="absolute top-[13px] left-20 text-gray-600 cursor-pointer">
                <IoMdClose size={22} onClick={() => handleClearInput()} />
              </div>
            )}
          </div>
          <div className={`errorPlace`}>
            {formik.touched.password && formik.errors.password ? (
              <div className="fv-plugins-message-container flex mt-1">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="red"
                  className="bi bi-exclamation-triangle-fill"
                  viewBox="0 0 16 16"
                >
                  <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" />
                </svg>
                <div className="fv-help-block d-inline-block mr-1 text-xs text-red-400">
                  {formik.errors.password}
                </div>
              </div>
            ) : null}
          </div>
          <div className="fv-plugins-icon-container relative mt-5 border rounded-md ">
            {showKeyConfirm && (
              <Modal
                sx={{
                  "& .muirtl-i9fmh8-MuiBackdrop-root-MuiModal-backdrop": {
                    backgroundColor: "transparent",
                  },
                }}
                open={showKeyConfirm}
                onClose={() => {
                  setShowKeyConfirm(false);
                }}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
              >
                <div
                  style={{
                    display: "flex",
                    backgroundColor: "#ffffff",
                    zIndex: 100,
                    borderRadius: 5,
                    position: "absolute",
                    top: "50%",
                    left: "17%",
                    transform: "translate(0%, -18%)",
                    outline: 0,
                    border: 0,
                    boxShadow: 24,
                    maxWidth: "100%",
                    width: "auto",
                    maxHeight: "80vh",
                    overflowY: "auto",
                  }}
                >
                  <div style={{ direction: "ltr" }}>
                    <Keyboard
                      input={confirmPass} // Pass the input directly
                      layoutName={layoutName}
                      onChange={onChange}
                      onKeyPress={onKeyPress}
                    />
                  </div>
                </div>
              </Modal>
            )}
            <input
              placeholder="تکرار رمز عبور"
              type={showConfirm ? "text" : "password"}
              className={`w-full  h-12 py-4 px-5 focus:border-gray-400 outline-none rounded-md ${getInputClasses(
                "confirmPassword",
              )} authInput`}
              name="confirmPassword"
              onChange={formik.handleChange}
              value={formik.values.confirmPassword}
              {...formik.getFieldProps("confirmPassword")}
            />

            <div
              className="absolute top-3 left-12 text-gray-600 cursor-pointer"
              onClick={() => handleClickConfirm()}
            >
              {showConfirm ? (
                <AiOutlineEyeInvisible size={25} />
              ) : (
                <AiOutlineEye size={25} />
              )}
            </div>
            <div className="absolute top-[13px] left-4 text-gray-600 cursor-pointer">
              <MdOutlineKeyboardAlt
                size={25}
                onClick={() => setShowKeyConfirm((prev) => !prev)}
                style={{ cursor: "pointer" }}
              />
            </div>
            {formik.values.confirmPassword !== null && (
              <div className="absolute top-[13px] left-20 text-gray-600 cursor-pointer">
                <IoMdClose
                  size={22}
                  onClick={() => handleClearInputConfirm()}
                />
              </div>
            )}
          </div>
          <div className={`errorPlace`}>
            {formik.touched.confirmPassword && formik.errors.confirmPassword ? (
              <div className="fv-plugins-message-container flex mt-1">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="red"
                  className="bi bi-exclamation-triangle-fill"
                  viewBox="0 0 16 16"
                >
                  <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" />
                </svg>
                <div className="fv-help-block d-inline-block mr-1 text-xs text-red-400">
                  {formik.errors.confirmPassword}
                </div>
              </div>
            ) : null}
          </div>
          <div className="fv-plugins-icon-container mt-5  ">
            <div className="flex items-center">
              <TextField
                size="small"
                placeholder="کد امنیتی"
                type="tel"
                inputMode="numeric"
                pattern="[0-9]*"
                sx={{}}
                className={`w-full border h-12 py-4  focus:border-gray-400 outline-none rounded-md ${getInputClasses(
                  "Otp",
                )} authInput`}
                name="Otp"
                {...formik.getFieldProps("Otp")}
                onChange={(event) => {
                  formik.setFieldValue(
                    "Otp",
                    event.target.value.replace(/\s/g, ""),
                  );
                }}
                InputProps={{
                  endAdornment: (
                    <>
                      <Button
                        variant="contained"
                        color="primary"
                        style={{ width: 140 }}
                        onClick={() => {
                          handleSendOtp();
                          if (isLoadingOtp) return;
                          setStartTimer(true);
                          setMinutes(1);
                          setSeconds(59);
                        }}
                        disabled={startTimer || isLoadingOtp}
                      >
                        <>
                          {isLoadingOtp ? (
                            <CircularProgress size={18} />
                          ) : startTimer ? (
                            <div style={{ minWidth: 45 }}>
                              <h1 className="text-center">
                                {minutes < 10 ? `0${minutes}` : minutes}:
                                {seconds < 10 ? `0${seconds}` : seconds}
                              </h1>
                            </div>
                          ) : (
                            "ارسال کد"
                          )}
                        </>
                      </Button>
                    </>
                  ),
                }}
                inputProps={{
                  style: {
                    textAlign: "right",
                    direction: "rtl",
                  },
                }}
              />
            </div>
            <div className={`errorPlace`}>
              {formik.touched.Otp && formik.errors.Otp ? (
                <div className="fv-plugins-message-container flex mt-1">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="15"
                    height="15"
                    fill="red"
                    className="bi bi-exclamation-triangle-fill"
                    viewBox="0 0 16 16"
                  >
                    <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" />
                  </svg>
                  <div className="fv-help-block d-inline-block mr-1 text-xs text-red-400">
                    {formik.errors.Otp}
                  </div>
                </div>
              ) : null}
            </div>
          </div>
          <div className="fv-plugins-icon-container mt-5  ">
            <div className="flex items-center">
              <TextField
                size="small"
                placeholder="کپچا"
                type="tel"
                inputMode="numeric"
                pattern="[0-9]*"
                sx={{}}
                className={`w-full border h-12 py-4  focus:border-gray-400 outline-none rounded-md ${getInputClasses(
                  "captcha",
                )} authInput`}
                name="captcha"
                {...formik.getFieldProps("captcha")}
                onChange={(event) => {
                  formik.setFieldValue(
                    "captcha",
                    event.target.value.replace(/\s/g, ""),
                  );
                }}
                InputProps={{
                  endAdornment: (
                    <>
                      {apiResponse?.response?.data?.img ? (
                        <img
                          style={{ maxHeight: 36 }}
                          height={16}
                          alt=""
                          src={imgSrc}
                        />
                      ) : (
                        <div
                          style={{
                            minWidth: 70,
                            justifyContent: "center",
                            alignItems: "center",
                            display: "flex",
                          }}
                        >
                          <CircularProgress size={16} />
                        </div>
                      )}
                      <MdOutlineRefresh
                        onClick={handleRefreshClick}
                        style={{ cursor: "pointer", marginInlineStart: 4 }}
                        size={44}
                      />
                    </>
                  ),
                }}
                inputProps={{
                  style: {
                    textAlign: "right",
                    direction: "rtl",
                  },
                }}
              />
            </div>
            <div className={`errorPlace`}>
              {formik.touched.captcha && formik.errors.captcha ? (
                <div className="fv-plugins-message-container flex mt-1">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="15"
                    height="15"
                    fill="red"
                    className="bi bi-exclamation-triangle-fill"
                    viewBox="0 0 16 16"
                  >
                    <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" />
                  </svg>
                  <div className="fv-help-block d-inline-block mr-1 text-xs text-red-400">
                    {formik.errors.captcha}
                  </div>
                </div>
              ) : null}
            </div>
          </div>
          <button
            type="submit"
            disabled={
              formik.values.password.length <= 8 &&
              formik.values.Otp.length < 4 &&
              formik.values.captcha.length <= 4 &&
              formik.values.confirmPassword.length <= 8
            }
            className={`w-full  text-white rounded-lg h-10 mt-5 text-sm mb-6 flex justify-center items-center`}
            style={
              formik.values.password.length >= 8 &&
              formik.values.Otp.length > 4 &&
              formik.values.captcha.length >= 4 &&
              formik.values.confirmPassword.length >= 8
                ? { backgroundColor: "#099C55" }
                : { backgroundColor: "#F8F8F8", color: "#C9C9C9" }
            }
          >
            {loading ? <CircularProgress size={30} /> : "ثبت"}
          </button>
        </form>
      </div>
    </>
  );
};

export default ChangePasswordWithoutAuth;
